import { useStaticQuery, graphql } from 'gatsby';

export const useCourseReviewDataQuery = () => {
  const CourseReviewDataList = useStaticQuery(graphql`
    query coursReviewDataQuery {
      allCourseList33ReviewXlsxSheet1 {
        edges {
          node {
            class_code
            review
            reviewer
            star_rate
            date
          }
        }
      }
    }
  `);
  return CourseReviewDataList;
};
